import { render, staticRenderFns } from "./StageAgreement.vue?vue&type=template&id=19fb45a5&scoped=true"
import script from "./StageAgreement.vue?vue&type=script&lang=js"
export * from "./StageAgreement.vue?vue&type=script&lang=js"
import style0 from "./StageAgreement.vue?vue&type=style&index=0&id=19fb45a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fb45a5",
  null
  
)

export default component.exports